import { Add } from '@/icons'
import type { IAvailableApps } from '@/utils/availableApps'
import { Box, useDisclosure } from '@chakra-ui/react'
import { MenuItem } from './MenuItem'

export const NewInsuranceButtonCarkulka = ({
  app,
}: {
  app: IAvailableApps['appId']
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  let closeTimeout: ReturnType<typeof setTimeout>

  return (
    <Box
      sx={{ position: 'relative' }}
      onMouseEnter={() => {
        clearTimeout(closeTimeout)
        onOpen()
      }}
      onMouseLeave={() => {
        closeTimeout = setTimeout(() => onClose(), 300)
      }}
    >
      <MenuItem variant="solid" colorScheme="primary" to={`/${app}/wizard/1?new`}>
        <Add />
        Nové pojištění
      </MenuItem>

      {isOpen && (
        <Box
          sx={{
            position: 'absolute',
            top: '100%',
            pt: 2,
            w: 'max-content',
          }}
        >
          <MenuItem
            variant="outline"
            colorScheme="gray"
            to={`/${app}/extra/wizard/1?new`}
            sx={{ boxShadow: 'md' }}
          >
            <Add color="secondary.500" />
            Nové pojištění doplňků
          </MenuItem>
        </Box>
      )}
    </Box>
  )
}